import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RainbowKitProvider, darkTheme, getDefaultConfig } from "@rainbow-me/rainbowkit";
import { WagmiProvider, http } from "wagmi";
import "@rainbow-me/rainbowkit/styles.css";
import "./styles.css";
import "./launch-controls.css";
import App from "./App";
import { wagmiChains } from "./config";

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || "2a43b72f4497f5a1519074a590930219";
const transports = Object.fromEntries(wagmiChains.map((chain) => [chain.id, http(chain.rpcUrls.default.http[0])]));
const config = getDefaultConfig({ appName: "RevShare Decentralized Launcher", projectId, chains: wagmiChains, transports });
const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={darkTheme({ accentColor: "#22d3ee", accentColorForeground: "#06131a", borderRadius: "large" })}>
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>,
);
